export const categories = {
    139: "Blockchain",
    143: "Development",
    141: "Guide",
    138: "Marketing",
    135: "News",
    1: "Design",
    142: "Web3"
};